import { render, staticRenderFns } from "./LogGeracaoReport.vue?vue&type=template&id=f38c9674"
import script from "./LogGeracaoReport.vue?vue&type=script&lang=js"
export * from "./LogGeracaoReport.vue?vue&type=script&lang=js"
import style0 from "./LogGeracaoReport.vue?vue&type=style&index=0&id=f38c9674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports